export const RECORDS_PER_PAGE = 20;

export const getSchemaRecordPageKey = (schemaName: string) =>
  `schema-record-${schemaName}`;
